import { CSSProperties } from 'react';
import { Handle, HandleProps } from 'reactflow';

export default function CustomHandle(props: HandleProps & { style: CSSProperties }) {
  return (
    <Handle
      {...props}
      style={{
        ...props.style,
        width: 16,
        height: 16,
        background: 'white',
        border: '2px solid black',
      }}
    />
  );
}
